import Header from "../../../shared/components/layout/Header";
import Wrapper from "../../../shared/components/layout/Wrapper";
import Footer from "../../../shared/components/layout/Footer";
import SEO from "../../../shared/components/layout/SEO";
import { useLanguage } from "../../../context/LanguageProvider";
import { useRules } from "../hooks/useRules";

const Rules = () => {
    const { lang, t } = useLanguage();
    const { rules, loading } = useRules(lang);

    return (
        <>
            <SEO
                title={t.seo.rules.title}
                description={t.seo.rules.description}
                path="/rules"
            />

            <div className="flex flex-col min-h-screen">
                <Header />

                <Wrapper className="flex-1 my-10">
                    {/* Full width on phones, narrower on larger screens */}
                    <div className="w-full md:w-3/4 lg:w-1/2 mx-auto relative">
                        {!loading &&
                            rules.map((rule, index) =>
                                rule.type === "heading" ? (
                                    <h3
                                        key={index}
                                        className="text-lg font-bold text-gray-900 mt-6 mb-3"
                                    >
                                        {rule.text}
                                    </h3>
                                ) : (
                                    <p
                                        key={index}
                                        className="text-gray-700 leading-8 mb-4 whitespace-pre-line"
                                    >
                                        {rule.text}
                                    </p>
                                )
                            )}
                    </div>
                </Wrapper>

                <Footer />
            </div>
        </>
    );
};

export default Rules;